import { render } from "./CurrencyConverter.vue?vue&type=template&id=007074ad&scoped=true"
import script from "./CurrencyConverter.vue?vue&type=script&lang=js"
export * from "./CurrencyConverter.vue?vue&type=script&lang=js"

import "./CurrencyConverter.vue?vue&type=style&index=0&id=007074ad&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007074ad"]])

export default __exports__